import { Deserializable } from '../protocols/deserializable';

export class RemittanceStatusType implements Deserializable {
  public id!: number;
  public name!: string;

  public onDeserialize() {}
}
